import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { validateRedirectPath } from '@/config/auth';

export const TokenExpiredScreen: React.FC = () => {
  const [searchParams] = useSearchParams();

  const retryHref = useMemo(() => {
    const validated = validateRedirectPath(searchParams.get('redirect'));
    // One login for every portal role (DD-026).
    return validated
      ? `/portal/login?redirect=${encodeURIComponent(validated)}`
      : '/portal/login';
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-linear-to-br from-blue-50 to-cyan-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md text-center">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Accesso Scaduto</h1>
        <p className="text-gray-600 mb-6">
          Il tuo link di accesso e scaduto. Inserisci la tua email per riceverne uno nuovo.
        </p>
        <Link
          to={retryHref}
          replace
          className="block w-full text-center px-4 py-3 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 transition-colors"
        >
          Richiedi un nuovo link
        </Link>
      </div>
    </div>
  );
};

export default TokenExpiredScreen;
